import { project } from './initializeStats.js';
import { statsArticle } from './statsArticle.js';
import { inViewport } from './elementsInViewport.js';
import { linkStats, setStatElementCollector, shareStats } from './stats.js';
import { wideo } from './wideo.js';
import { menu } from './menu.js';
import { anchors } from './anchors.js';
import { debounce } from './helpers.js';
import { accordion, resizeAccordion } from './widgets/accordeon.js';
import { beforeAfter } from './widgets/beforeAfter.js';
import { galleryHover } from './widgets/galleryHover.js';
import { timeline } from './widgets/timeline.js';
import { sliderSwiperWindow, sliderSwiperWide } from './widgets/slider.js';
import { audioPlay } from './widgets/audio.js';
import { hotpoints } from './widgets/hotpoints.js';
import { handleFormCompetition } from './_formCompetition.js';
import { loadMore } from './loadMore.js';

anchors();
statsArticle();
setStatElementCollector();
linkStats();
inViewport();
shareStats();
menu();
accordion();
beforeAfter();
galleryHover();
timeline();
sliderSwiperWindow();
sliderSwiperWide();
audioPlay();
hotpoints();

loadMore('.__jsMoreTarget');


const scrollToVideo = function (el) {
	if (!(el instanceof Element)) return;
	const y = el.getBoundingClientRect().top + window.scrollY;
	const offset = document.querySelector('header.header').getBoundingClientRect().height;
	window.scrollTo({
		top: y - offset - 10,
		behavior: 'smooth'
	});
}

document.querySelectorAll('.player').forEach((el) => {

	wideo(el);

	//przełącznik wideo na jednej instancji, dodatkowo ze zmianą opisów
	if (el.classList.contains('__jsPlayerSG')) {
		const desc = el.parentNode.querySelector('.player__opis');
		el.closest('.teasers__container').querySelectorAll('.__jsNextItem').forEach((item) => {

			const url = 'https://wideo.wp.pl/player/embed.json?mid=' + /mid=([0-9]+)/.exec(item.dataset.url)[1] + '/secured';
			
			fetch(url)
				.then(response => {
					if (!response.ok) {
						item.querySelector('img').src = 'http://nsm-niemcy-polnocne-2025.wpcdn.pl/i/player-poster-domain.jpg';
						
						throw new Error('Nie zaczytuje się response');												
					}
					return response.json();
				})
				.then(data => {
					let imgSrc = new URL(data.clip.screenshot);
						imgSrc = 'https://i.wpimg.pl/360x240/' + imgSrc.hostname + imgSrc.pathname;

					item.querySelector('img').src = imgSrc;
				});


			item.addEventListener("click", e => {

				if (desc.querySelector('h3').length) {
					desc.querySelector('h3').innerHTML = item.querySelector('.teaser__title span').innerHTML;	
				}
				if (item.querySelector('.teaser__desc p') && desc.querySelector('p')) {					
					desc.querySelector('p').innerHTML = item.querySelector('.teaser__desc p').innerHTML;
				} else {					
					desc.querySelector('p').innerHTML = '';
				}
				
				e.target.closest('.teasers__container').querySelectorAll('.__jsNextItem').forEach((citem) => {
					if (citem == item) {
						citem.classList.add('__jsActive');
					} else {
						citem.classList.remove('__jsActive');
					}
				});

				let instance = WP.player.list.find(x => x.id === el.firstChild.id);
				if (instance) {
					instance.setUrl(item.dataset.url);
					setTimeout(() => {
						if (!instance.isPlaying())
							instance.setUrl(item.dataset.url);
						scrollToVideo(el);
					}, 250);
				}
			});
		});
	}
});


let sendStats = function () { }

const changeSizesOnResize = () => {
	resizeAccordion();
};

window.addEventListener('resize', debounce(changeSizesOnResize, 500));

window.addEventListener('beforeunload', project.unloadData.bind(project));

// for testing
// document.querySelector('.header').addEventListener('click', project.unloadData.bind(project));

if (document.querySelectorAll('.swiper.__ver_video').length) {
	document.querySelectorAll('.swiper.__ver_video').forEach((v) => {
		const videoSlider = v;
		const btnPrev = videoSlider.querySelector('.swiper-button-prev');
		const btnNext = videoSlider.querySelector('.swiper-button-next');

		//let swiperInstance = this;

		new Swiper('.swiper.__ver_video', {
			slidesPerView: 1,
			centeredSlides: true,
			loop: true,
			spaceBetween: 50,
			navigation: {
				nextEl: btnNext,
				prevEl: btnPrev,
			},
			breakpoints: {
				1020: {
					slidesPerView: 1,
					spaceBetween: 90
				}
			},
			on: {
				'realIndexChange': (swiper) => {
					const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';
					const eventCategory = swiper.el.dataset.ga360Id ? swiper.el.dataset.ga360Id : 'ERROR ga360';
					const artId = swiper.el.closest('.__js_stats_wrapper') ? swiper.el.closest('.__js_stats_wrapper').getAttribute('data-id') : 'ERROR No stats section';
					const dataId = swiper.el.dataset.id ? swiper.el.dataset.id : 'ERROR no id';
					const itemSource = swiper.el.querySelector('.player').dataset.url;

					sendStats(
						'gallery',
						eventAction,
						`${artId} / ${dataId}`,
						itemSource
					);

					window.dataLayer.push(
						{
							event: 'content_interaction',
							eventCategory: eventCategory,
							moduleName: dataId,
							eventAction: eventAction
						}
					);

				}
			}
		});
	})
}